export const UserType: Record<string, Users.Type> = {
  Admin: 'admin',
  Homeowner: 'homeowner',
  Partner: 'partner',
};
